module.exports = __webpack_public_path__ + "static/portfolio-mas-7-a7628798fbff7fce04a10a8e43df8ee8.jpg";